export const SHOWED_TUTORIAL = "showed_tutorial"
export const IS_FACING_PAGE = "is_facing_page"
export const PAGE_DIRECTION = "page_direction"
